function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { getTimeNow } from './time-util';
/**
 * Intervals in JS are never exact
 *
 * Each execution will receive as a parameter the actual elapsed time since
 * the previous execution
 */ /**
 * It's generally preferred not to use setInterval
 *
 * In low performance conditions, setInterval calls may queue
 * up on one another and cause inaccurate measurement or
 * make performance even worse
 */ export var SafeInterval = /*#__PURE__*/ function() {
    "use strict";
    function SafeInterval(config) {
        _class_call_check(this, SafeInterval);
        _define_property(this, "config", void 0);
        _define_property(this, "currentHandle", void 0);
        _define_property(this, "lastRunTime", void 0);
        this.config = config;
        this.lastRunTime = getTimeNow();
    }
    _create_class(SafeInterval, [
        {
            key: "start",
            value: function start() {
                this.stop();
                this.schedule();
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.currentHandle === undefined) {
                    return;
                }
                clearTimeout(this.currentHandle);
            }
        },
        {
            key: "schedule",
            value: function schedule() {
                var _this = this;
                this.currentHandle = setTimeout(function() {
                    var elapsed = getTimeNow() - _this.lastRunTime;
                    _this.lastRunTime = getTimeNow();
                    _this.config.executor(elapsed);
                    _this.schedule();
                }, this.config.timeMs);
            }
        }
    ]);
    return SafeInterval;
}();

//# sourceMappingURL=safe-interval.js.map